import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { AddPageWithRoaryModal } from './AddPageWithRoaryModal';
import { RoaryProgress } from './RoaryProgress';
import { useRoaryBuildPage } from '../../hooks/useRoaryBuildPage';
import roaryMascot from '/assets/Roary-mascot.png';

interface RoaryAddPageFlowProps {
  isOpen: boolean;
  onClose: () => void;
  siteId: string;
}

export const RoaryAddPageFlow: React.FC<RoaryAddPageFlowProps> = ({ isOpen, onClose, siteId }) => {
  const navigate = useNavigate();
  const { isBuilding, buildProgress, error, startBuild, cancelBuild, setError } =
    useRoaryBuildPage();

  const handleClose = async () => {
    if (isBuilding) {
      await cancelBuild();
    }
    setError(null);
    onClose();
  };

  return (
    <>
      <AddPageWithRoaryModal
        isOpen={isOpen && !isBuilding && !error}
        onClose={handleClose}
        onSubmit={values => {
          startBuild(siteId, values, result => {
            onClose();
            navigate(`/sites/${result.siteId}/pages/${result.pageId}/editor?roary=1`);
          });
        }}
      />

      {(isBuilding || error) && (
        <div className="fixed inset-0 z-50 bg-[#0a0a1a] flex flex-col">
          <header className="flex items-center justify-between px-6 py-4 border-b border-slate-800/50">
            <div className="flex items-center gap-3">
              <img src={roaryMascot} alt="Roary" className="w-12 h-12 object-contain" />
              <div>
                <h1 className="text-white font-semibold text-lg">Roary</h1>
                <p className="text-gray-500 text-sm">Building your page</p>
              </div>
            </div>
            <button
              type="button"
              onClick={handleClose}
              className="p-2 text-gray-400 hover:text-white hover:bg-slate-800 rounded-lg"
              title="Cancel"
            >
              <X className="w-5 h-5" />
            </button>
          </header>
          <div className="flex-1 overflow-hidden">
            {error ? (
              <div className="h-full flex flex-col items-center justify-center p-8 text-center">
                <p className="text-red-300 mb-4">{error}</p>
                <button type="button" onClick={handleClose} className="btn-primary">
                  Close
                </button>
              </div>
            ) : (
              <RoaryProgress
                operations={[]}
                isStreaming
                currentToolName={null}
                buildProgress={buildProgress}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
